export enum ActionStepFirmProvisionStatusType {
    Pending = 0,
    SyncInitiated = 1,
    SyncComplete = 2,
    MappingInitiated = 3,
    MappingComplete = 4,
    Complete = 5,
    DoNotProvision = 6,
    Failed = 7
}

export function GetActionStepFirmProvisionStatusType(actionStepProvisioningStatus: string): ActionStepFirmProvisionStatusType {

    if (!actionStepProvisioningStatus || actionStepProvisioningStatus.length === 0) {
        return ActionStepFirmProvisionStatusType.DoNotProvision;
    }

    switch (actionStepProvisioningStatus.toLocaleLowerCase()) {
        case 'pending':
            return ActionStepFirmProvisionStatusType.Pending;
        case 'complete':
            return ActionStepFirmProvisionStatusType.Complete;
        case 'syncinitiated':
            return ActionStepFirmProvisionStatusType.SyncInitiated;
        case 'synccomplete':
            return ActionStepFirmProvisionStatusType.SyncComplete;
        case 'mappinginitiated':
            return ActionStepFirmProvisionStatusType.MappingInitiated;
        case 'mappingcomplete':
            return ActionStepFirmProvisionStatusType.MappingComplete;
        case 'failed':
            return ActionStepFirmProvisionStatusType.Failed;
        default:
            return ActionStepFirmProvisionStatusType.DoNotProvision;
    }
}